<template>
    <div class="bank-detail-container">
      <div class="header">
        <h3>Банковские реквизиты</h3>
        <button class="add-button" @click="openModal(null)">Добавить</button>
      </div>
      <ul class="bank-list" v-if="executor.company.bank_details">
        <li v-for="bank in bankDetails" :key="bank.id" class="bank-item">
          <div class="bank-info">
            <p><strong>Расчетный счет:</strong> {{ bank.account_number }}</p>
            <p><strong>Банк:</strong> {{ bank.bank_name }}</p>
            <p><strong>БИК:</strong> {{ bank.bik }}</p>
            <p><strong>Кор. счет:</strong> {{ bank.correspondent_account }}</p>
          </div>
          <div class="bank-actions">
            <button class="edit-button" @click="openModal(bank)">Изменить</button>
            <button class="delete-button" @click="deleteBankDetail(bank.id)">Удалить</button>
          </div>
        </li>
      </ul>
  
      <!-- Модальное окно -->
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <h3>{{ editingBank ? 'Редактировать реквизит' : 'Добавить реквизит' }}</h3>
          <form @submit.prevent="saveBankDetail">
            <div class="form-group">
              <label for="account">Расчетный счет</label>
              <input id="account" v-model="form.account_number" required />
            </div>
            <div class="form-group">
              <label for="bank">Банк</label>
              <input id="bank" v-model="form.bank_name" required />
            </div>
            <div class="form-group">
              <label for="bic">БИК</label>
              <input id="bic" v-model="form.bik" required />
            </div>
            <div class="form-group">
              <label for="correspondent_account">Кор. счет</label>
              <input id="correspondent_account" v-model="form.correspondent_account" required />
            </div>
            <div class="form-actions">
              <button type="button" class="save-button" @click="saveBankDetail">Сохранить</button>
              <button type="button" class="cancel-button" @click="closeModal">Отмена</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>

  import executors from '@/store/modules/executors';
import { ref } from 'vue';
  
  export default {
    name: 'BankDetail',
    props: ['company','executor'],
    setup(props,{emit}) {
      const bankDetails = props.executor.company.bank_details; // Список банковских реквизитов
      const showModal = ref(false);
      const editingBank = ref(null); // Редактируемый реквизит
      const form = ref({
        account_number: '',
        bank_name: '',
        bik: '',
        correspondent_account: '',
        company_id: props.company.id
      });
  
      // Открыть модальное окно
      const openModal = (bank) => {
        if (bank) {
          editingBank.value = bank;
          Object.assign(form.value, bank);
        } else {
          editingBank.value = null;
          form.value = {
            account_number: 'asdfsa',
            bank_name: 'asdfsadf',
            bik: 'werqwr',
            correspondent_account: 'asdfasdf',
            company_id: props.company.id
          };
        }
        showModal.value = true;
      };
  
      // Закрыть модальное окно
      const closeModal = () => {
        showModal.value = false;
      };
  
      // Сохранить реквизит
      const saveBankDetail = () => {
        if (editingBank.value) {
          emit("UpdateBank",form.value);
        } else {
          emit("AddBank",form.value)
        }
        closeModal();
      };
  
      // Удалить реквизит
      const deleteBankDetail = (id) => {
        emit("DeleteBank",id)
      };
  
      return {
        bankDetails,
        showModal,
        form,
        editingBank,
        openModal,
        closeModal,
        saveBankDetail,
        deleteBankDetail,
      };
    },
  };
  </script>
  
  <style scoped>
  .bank-detail-container {
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 10px;
    margin-top: 15px;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .add-button {
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .bank-list {
    list-style: none;
    padding: 0;
  }
  
  .bank-item {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
  }
  
  .bank-actions button {
    margin-left: 5px;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    width: 400px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-actions {
    display: flex;
    justify-content: space-between;
  }
  </style>
  